import { Link } from "@/components/Link";
import type { TestResultDetail } from "../../types";
import { useAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TabLayout } from "../TabLayout";

export function ResultResultSpecsTable({
  result,
}: {
  result: TestResultDetail;
}) {
  const resultSpecs = result.testResultSpecs;

  const { options } = useAdminGridOptions(
    resultSpecs,
    [
      {
        field: "name",
        headerName: "Result spec",
        cellRendererParams: (info) => ({
          data: info.data,
        }),
        cellRenderer: (info) => (
          <Link
            to="/admin/tests/$id/edit/results/$specId"
            params={{ id: info.data.testId, specId: info.data.id }}
          >
            {info.data.name}
          </Link>
        ),
      },
      {
        field: "testSpec.name",
        headerName: "Name",
        flex: 1,
        minWidth: 200,
        cellRenderer: (info) => (
          <Link
            to="/admin/tests/$id/edit"
            params={{ id: info.data.testSpec.id }}
          >
            {info.data.testSpec.name}
          </Link>
        ),
      },
      {
        field: "testSpec.code",
        headerName: "Code",
        width: 140,
        maxWidth: 200,
      },
    ],
    { sideBar: undefined },
  );

  return (
    <TabLayout
      description="The following clients are allowed to select this panel during order
    entry"
    >
      <div className="flex h-96">
        <AdminGrid {...options} />
      </div>
    </TabLayout>
  );
}
